export default __webpack_public_path__ + "static/media/hango-screenshot-03.5295a2b6.png";